<template>
  <div v-if="securityClassList.length">
    <v-row class="mt-5">
      <v-col cols="4"><div class="pt-2 title">Security Points</div></v-col>
      <v-col cols="8" class="text-right"
        ><v-btn outlined color="primary" @click="showForm">Add</v-btn></v-col
      >
    </v-row>

    <div class="och-table" v-if="filteredFunctionInputList">
      <v-data-table
        :headers="headers"
        :items="filteredFunctionInputList"
        :search="search"
        hide-default-footer
        sort-by="name"
      >
        <template v-slot:no-data>
          <i>No functions created or associated</i>
        </template>
        <template v-slot:body.append v-if="showCreateForm">
          <tr style="border-left: 10px solid grey" class="px-3">
            <td>
              <v-autocomplete
                :items="typeList"
                @change="changeType"
                class="my-4"
                dense
                hide-details
                item-text="name"
                item-value="name"
                outlined
                v-model="record.type"
              >
              </v-autocomplete>
            </td>
            <td>
              <v-autocomplete
                :disabled="!record.type"
                :items="getItemList(record.type)"
                class="my-4"
                dense
                hide-details
                item-text="displayName"
                item-value="item"
                outlined
                v-model="record.point"
              >
              </v-autocomplete>
            </td>
            <td>
              <v-autocomplete
                :disabled="!record.type"
                :items="operatorList"
                class="my-4"
                dense
                hide-details
                item-text="name"
                item-value="name"
                outlined
                v-model="record.operator"
              >
              </v-autocomplete>
            </td>
            <td>
              <v-text-field
                :disabled="!(record.type && record.point)"
                class="my-4"
                dense
                hide-details
                outlined
                v-model="record.value"
              ></v-text-field>
            </td>
            <td class="text-right">
              <v-btn @click="showCreateForm = false" small outlined
                >Cancel</v-btn
              >
              <v-btn
                @click="save"
                class="elevation-0 ml-2"
                color="primary"
                small
                :disabled="
                  !(record.type && record.point && record.value) || !isUnique
                "
                >Save</v-btn
              >
              <div v-if="!isUnique" class="error--text mt-3">
                <v-icon small color="error">fas fa-exclamation-triangle</v-icon>
                This security point combination already exists.
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr v-if="record.id === item.id" style="border-left: 10px solid grey">
            <td>
              <v-autocomplete
                :items="typeList"
                @change="changeType"
                class="my-4"
                dense
                hide-details
                item-text="name"
                item-value="name"
                outlined
                v-model="record.type"
              >
              </v-autocomplete>
            </td>
            <td>
              <v-autocomplete
                :disabled="!record.type"
                :items="getItemList(record.type)"
                class="my-4"
                dense
                hide-details
                item-text="displayName"
                item-value="item"
                outlined
                v-model="record.point"
              >
              </v-autocomplete>
            </td>
            <td>
              <v-autocomplete
                :disabled="!record.type"
                :items="operatorList"
                class="my-4"
                dense
                hide-details
                item-text="name"
                item-value="name"
                outlined
                v-model="record.operator"
              >
              </v-autocomplete>
            </td>
            <td>
              <v-text-field
                :disabled="!(record.type && record.point)"
                class="my-4"
                dense
                hide-details
                outlined
                v-model="record.value"
              ></v-text-field>
            </td>
            <td class="text-right">
              <v-btn @click="record = {}" small outlined>Cancel</v-btn>
              <v-btn
                @click="save"
                class="elevation-0 ml-2"
                color="primary"
                small
                :disabled="
                  !(record.type && record.point && record.value) || !isUnique
                "
                >Save</v-btn
              >
              <div v-if="!isUnique" class="error--text mt-3">
                <v-icon small color="error">fas fa-exclamation-triangle</v-icon>
                This security point combination already exists.
              </div>
            </td>
          </tr>
          <tr v-else @click="editSecurityPoint(item)" class="och-tableRow">
            <td>
              {{ item.type }}
            </td>
            <td>
              {{
                getItemList(item.type).find(
                  listItem => listItem.item === item.point
                ).name || "[Unnamed]"
              }}
              ({{ item.point }})
            </td>
            <td>
              {{ item.operator }}
            </td>
            <td>
              {{ item.value }}
            </td>
            <td class="text-right">
              <v-btn @click.stop="copyFunctionInput(item)" icon small
                ><v-icon small color="primary">far fa-copy</v-icon></v-btn
              >
              <v-btn @click.stop="removeFunctionInput(item.id)" icon small
                ><v-icon small color="primary">fas fa-trash</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: {
    filteredFunctionInputList() {
      return this.filterFunctionInput("secFunctionId", this.functionId);
    },
    formattedSecurityClassList() {
      return this.securityClassList.map(item => {
        item.displayName = `${item.name} (${item.id})`;
        return item;
      });
    },
    functionId() {
      return parseInt(this.$route.params.functionId, 10);
    },
    isUnique() {
      const filteredList = this.filterFunctionInput(
        "secFunctionId",
        this.functionId
      );
      const found = filteredList.find(item => {
        return (
          item.type === this.record.type &&
          item.point === this.record.point &&
          item.value === this.record.value &&
          item.id !== this.record.id
        );
      });
      if (found) {
        return false;
      }
      return true;
    },
    itemList() {
      return this.getItemList(this.record.type);
    },
    valueList() {
      return this.getValueList(this.record.point);
    },
    showRemoveButton() {
      return !!this.$listeners.remove;
    },
    ...mapGetters({
      filterFunctionInput: "secFunctionInput/filterByAttributeValue",
      filterSecurityClass: "securityClass/filterByAttributeValue",
      filterType: "epicApplicationType/filterByAttributeValue",
      getSecurityClassById: "securityClass/getById",
      getTypeById: "epicApplicationType/getById",
    }),
    ...mapState({
      list: state => state.secFunctionInput.list,
      operatorList: state => state.operator.list,
      securityClassList: state => state.securityClass.list,
      typeList: state => state.epicApplicationType.list,
    }),
  },
  async created() {
    await Promise.all([
      this.getFunctionInputList(),
      this.getSecurityClassList(),
    ]);
  },
  data() {
    return {
      headers: [
        {
          text: "Type",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "Item",
          value: "point",
          align: "start",
          sortable: false,
        },
        {
          text: "Operator",
          value: "operator",
          align: "start",
          sortable: false,
        },
        {
          text: "Value",
          value: "value",
          align: "start",
          sortable: false,
        },
        {
          text: " ",
          value: "",
          align: "start",
          sortable: false,
        },
      ],
      record: {
        operator: "contains",
      },
      search: null,
      showCreateForm: false,
    };
  },
  methods: {
    changeType() {
      delete this.record.point;
      delete this.record.value;

      const classType = this.filterType("name", this.record.type)[0];
      if (classType.itemType === "single" && this.itemList.length) {
        this.record.point = this.itemList[0].item;
      }
    },
    copyFunctionInput(item) {
      const { operator, point, type } = item;
      this.record = { operator, point, type };
      this.showCreateForm = true;
    },
    async displayClass(item) {
      return `${item.name} (${item.id})`;
    },
    async editSecurityPoint(item) {
      this.record = cloneDeep(item);
      this.showCreateForm = false;
    },
    getItemList(id) {
      if (!id) return [];
      const itemListByType = this.filterSecurityClass("type", id)
        .map(item => {
          const itemList = item.itemList;
          return itemList.map(listItem => {
            const { item, name, valueList } = listItem;
            return { displayName: `${name} (${item})`, name, item, valueList };
          });
        })
        .reduce((acc, val) => {
          return acc.concat(val);
        }, []);

      // Removes duplicates in ES6
      // (Source: https://medium.com/dailyjs/how-to-remove-array-duplicates-in-es6-5daa8789641c)
      const uniqueItemList = [...new Set(itemListByType)];

      return uniqueItemList.sort((a, b) => {
        return a.displayName < b.displayName ? -1 : 1;
      });
    },
    getValueList(item) {
      if (!item) return [];
      const selectedItem = this.itemList.find(listItem => {
        return listItem.item === item;
      });
      return selectedItem.valueList;
    },
    async removeFunctionInput(id) {
      await this.removeFunctionInput(id);
    },
    async save() {
      if (this.record.id) {
        await this.update([this.record.id, this.record]);
      } else {
        this.record.secFunctionId = this.functionId;
        await this.create(this.record);
      }
      this.showCreateForm = false;
      this.record = { operator: "contains" };
    },
    showForm() {
      this.record = { operator: "contains" };
      this.showCreateForm = true;
    },
    ...mapActions({
      create: "secFunctionInput/create",
      getFunctionInputList: "secFunctionInput/list",
      getSecurityClassList: "securityClass/list",
      removeFunctionInput: "secFunctionInput/remove",
      update: "secFunctionInput/update",
    }),
  },
  props: ["hideSearch"],
};
</script>
